<template>
  <div v-if="filteredCartRecs.length" class="cart__recs">
    <h3 v-if="items.length">Customers also bought</h3>
    <h3 v-else>Products you may like</h3>
    <div class="cart__recs-items">
      <div 
        v-for="(recs,index) in filteredCartRecs" 
        :key="recs.id"
        class="product-card card-sm"
      >
        <div class="product-card_inner">
          <div class="product-card_media">
            <a :href="`${siteRoutes}products/${recs.handle}`" class="product-card_media">
            <ImageField :obj="{'url':recs.image.src,'alt':recs.image.alt,'width':536,'height':536}" width-param="width" sizes="(max-width: 575px) 50vw, 210px"/>
            </a>
            <button @click="addRecToCart(recFirstOneTimeVariant(recs).id)" class="btn--add-to-cart" type="button" aria-label="Add product to cart"><svg class="icon"><use href="#cart-plus"></use></svg></button>
          </div>
          <div class="product-card_info">
            <a :href="recs.link" class="product-card_title">{{ recs.title }}</a>
            <div class="product-card_variants">
              <div class="product-card_reviews">
                <div class="yotpo bottomLine" data-appkey="SmtoQBJliJwFrBjSYjmEtOz31o6nMoLZfgcp3J4j" :data-product-id="recs.id" :data-yotpo-element-id="'mini-cart-' + recs.id"></div>
                <!--<svg class="icon"><use href="#star-filled"></use></svg>-->
              </div>
              <span v-if="recVariantTitle(recs)" class="product-card_variant">{{ recVariantTitle(recs) }}</span>
            </div>
            <div class="product-card_price">
              <span>{{ formatPrice(recFirstOneTimeVariant(recs).price) }}</span>
              <span v-if="recFirstOneTimeVariant(recs).price < recFirstOneTimeVariant(recs).compare_at_price">
                <s class="text-sm text-error">{{ formatPrice(recFirstOneTimeVariant(recs).compare_at_price) }}</s>
              </span>
            </div>

          </div>      
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, toRefs, onBeforeMount, onMounted, watch, watchEffect, nextTick } from 'vue';
  import ImageField from '../../global/image.vue';
  import {useStore} from "vuex";

  const props = defineProps({
    cartRecs: {
      type: Array,
      default: []
    },

    items: {
      type: Array,
      default: []
    }
  })

  const { cartRecs, items } = toRefs(props);
  const store = useStore();

  const filteredCartRecs = computed(() => {
    return cartRecs.value.filter(rec => !items.value.some(item => item.product_id === rec.id))
  })

  const recVariantTitle = (item) => {
    const variant = recFirstOneTimeVariant(item);

    if (item.type === "Merchandise" || variant.title === "Default Title") {
      return "";
    }

    let title = variant.title;

    if (variant.option1 === "Unflavored") {
      title = variant.option2;
    }

    // Return early if title is null or undefined to avoid replace errors
    if (title == null) {
      return title;
    }

    // Replace numbers with "serving" or "servings" where appropriate
    title = title.replace(/\b(\d+)\b(?!\s*(Tub|Tubs|Bottle|Bottles|Box|Boxes))/g, (match, p1) => {
      return p1 === "1" ? `${p1} Serving` : `${p1} Servings`;
    });

    // Remove " / One Time Purchase" or " | One Time Purchase"
    title = title.replace(/ \/\s*One Time Purchase$| \|\s*One Time Purchase$/, '');

    return title;
  }

  const recFirstOneTimeVariant = (rec) => {
    if (rec.options[2] && ["Tubs", "Bottles", "Boxes"].includes(rec.options[2].name)) {
      return rec.variants.find(variant => variant.option3 === "One Time Purchase") || rec.variants[0];
    }
    return rec.variants[0];
  }

  const addRecToCart = (id) => {
    store.dispatch("add", {
      id: id,
      quantity: 1
    })
  }

  const formatPrice = (price) => {
    return window.formattedPrice(price);
  }

  const siteRoutes = computed(() => {
    const root = window.Shopify?.routes?.root || '/'
    return root
  })

  watch(
    filteredCartRecs,
    () => {
      nextTick(() => {
        window.initYotpoData()
      });
    },
    { deep: true }
  );

  onMounted(() => {
    nextTick(() => {
      window.initYotpoData()
    });
  });
</script>